import React from "react";
import SingleSelectDropDown from "../../../../layouts/SingleSelectDropDown";
import FormTriggers from "../../../../layouts/FormTriggers";
import { verifyCheckBoxes } from "../../../../utils/detail";
import {
  compareTrancheDetails,
  maskString,
  maskPayeeAccountText,
  checkPayeeNameHavAcc,
} from "../../../../utils/helperFunctions";
import {
  OfflinePaymentModes,
  ReasonForDeviation,
  paymentMode,
} from "../../../../utils/constant";
import { formatAmount } from "../../../../utils/format";
import MultiSelectDropDown from "../../../../layouts/MultiSelectDropDown";
import { getVerifiedClsAndTxt } from "../../../../utils/TrancheFormFunctions";

const PayeeAndPayerDetails = ({
  payCount,
  state,
  formFieldState,
  setFormFieldState,
  payment,
  stepDetails,
  caseDetails,
  checkpoints,
  payeetypeList,
  tuComparable,
  disable,
  disableMaker,
  btnDisplayHOD,
  btnDisplayPaylead,
  user,
  dtsPaymentMax,
  handleInputChange,
  handleCheckboxChange,
  handleTriggerChange,
  toggleDropDown,
  dropdownContainer,
  validateOTP,
  validateAccNumberFunc,
  showTrancheChecklist,
}) => {
  const idx = payCount - 1;

  const toggleCancellationTooltip = (idx) => {
    formFieldState[idx].showCancellationTooltip =
      !formFieldState[idx].showCancellationTooltip;
    setFormFieldState([...formFieldState]);
  };

  const { verifiedCls, verifiedTxt } = getVerifiedClsAndTxt(payment);

  const payeeAccountNo = `payee_ac_number_${payCount}`;
  const payee_ac_number = payment.payee_ac_number
    ? payment.payee_ac_number
    : "";

  const existed_payee_account = payment.existed_payee_account
    ? payment.existed_payee_account
    : payee_ac_number;

  const checkPayeeAcNumber = checkpoints[payeeAccountNo] === "1" ? true : false;
  const uncheckPayeeAcNumber =
    checkpoints[payeeAccountNo] === "0" ? true : false;

  const tuMatchPayeeAcNumber = compareTrancheDetails(
    caseDetails,
    tuComparable,
    payeeAccountNo,
    payee_ac_number,
    payment.save_as_draft,
    user.id,
  );
  const trancheCancellationData = state.paymentTrancheDetails.cancellationData[
    idx
  ]
    ? state.paymentTrancheDetails.cancellationData[idx]
    : {};
  const trancheForClosureData = state.paymentTrancheDetails.forClosureData[idx]
    ? state.paymentTrancheDetails.forClosureData[idx]
    : {};
  let disableValues = true;

  const isForeclosure =
    Object.keys(trancheForClosureData).length &&
    trancheForClosureData.release_foreclosure_amount > 0;

  const isCancellation = Object.keys(trancheCancellationData).length > 1;

  if (isForeclosure || isCancellation) {
    disableValues = false;
  }
  const tuPayeeMatch =
    !Object.keys(tuComparable).length &&
    payment.save_as_draft &&
    caseDetails.dts_pay_count === payCount
      ? "col-red"
      : "";
  const defaultPayeeType = payment.payeeTypeVal;

  let payeeName = `payee_name_${payCount}`;
  let payee_name = payment.payeeNameVal ?? "",
    existed_payee_name = payment.existed_payee_name
      ? payment.existed_payee_name
      : payee_name;
  const checkPayeeName = checkpoints[payeeName] === "1" ? true : false;
  const uncheckPayeeName = checkpoints[payeeName] === "0" ? true : false;

  const checkPayeeType =
    checkpoints[`payee_type_${payCount}`] === "1" ? true : false;
  const uncheckPayeeType =
    checkpoints[`payee_type_${payCount}`] === "0" ? true : false;

  const checkPaymentMode =
    checkpoints[`payment_mode_${payCount}`] === "1" ? true : false;
  const uncheckPaymentMode =
    checkpoints[`payment_mode_${payCount}`] === "0" ? true : false;

  const payable_ac_number = `payable_ac_number_${payCount}`;
  const checkPayableAcNumber =
    checkpoints[payable_ac_number] === "1" ? true : false;
  const uncheckPayableAcNumber =
    checkpoints[payable_ac_number] === "0" ? true : false;
  const trancheName = `tranche_name_${payCount}`;
  const checkTrancheName = checkpoints[trancheName] === "1" ? true : false;
  const uncheckTrancheName = checkpoints[trancheName] === "0" ? true : false;
  const devitionReasonId = `devition_reason_id_${payCount}`;
  const checkDevitionReasonId =
    checkpoints[devitionReasonId] === "1" ? true : false;
  const uncheckDevitionReasonId =
    checkpoints[devitionReasonId] === "0" ? true : false;

  const previousFinancier = `previous_financier_${payCount}`;
  const previous_financier = payment.previous_financier
    ? payment.previous_financier
    : "";
  const checkPreviousFinancier =
    checkpoints[previousFinancier] === "1" ? true : false;
  const uncheckPreviousFinancier =
    checkpoints[previousFinancier] === "0" ? true : false;

  const tuMatchFinancier = compareTrancheDetails(
    caseDetails,
    tuComparable,
    previousFinancier,
    previous_financier,
    payment.save_as_draft,
    user.id,
  );

  const previousLoanAccount = `previous_loan_account_${payCount}`;
  const previous_loan_account = payment.previous_loan_account
    ? payment.previous_loan_account
    : "";
  const checkPreviousLoanAccount =
    checkpoints[previousLoanAccount] === "1" ? true : false;
  const uncheckPreviousLoanAccount =
    checkpoints[previousLoanAccount] === "0" ? true : false;

  const tuMatchLoanAccount = compareTrancheDetails(
    caseDetails,
    tuComparable,
    previousLoanAccount,
    previous_loan_account,
    payment.save_as_draft,
    user.id,
  );

  const showPreviousLoanDetails = false;
  const tuMatchPayeeName = compareTrancheDetails(
    caseDetails,
    tuComparable,
    payeeName,
    payee_name,
    payment.save_as_draft,
    user.id,
  );
  return (
    <>
      <tr>
        <td className={tuPayeeMatch}>
          Payee Type
          <span className="col-red">*</span>
        </td>
        <td>
          <SingleSelectDropDown
            dataArr={payeetypeList}
            handleChange={(e) => handleInputChange(e, idx, "payeeTypeVal")}
            name={`payee_type_${payCount}`}
            disabled={
              payment.disabledPayeeType
                ? payment.disabledPayeeType
                : disableValues
            }
            required={true}
            value={defaultPayeeType ? defaultPayeeType : ""}
            className={payment.payeeTypeClass}
            divClassName="form-group payment-dropdown-tranche-form"
          />
          <div className="errorTxt" id={`error_payee_type_${payCount}`}>
            {payment.errorpayeeTypeMsg}
          </div>
        </td>
        {stepDetails.checklist && showTrancheChecklist ? (
          <FormTriggers
            triggerName={`payee_type_${payCount}`}
            disabled={disable}
            showYesButton={
              verifyCheckBoxes(payment, user.dts_user) || checkPayeeType
            }
            showNoButton={
              verifyCheckBoxes(payment, user.dts_user) || uncheckPayeeType
            }
            errorClass={payment.showPayeeTypeTriggerError ? "has-error" : ""}
            triggerValues={checkpoints}
            caseDetails={caseDetails}
            handleTriggerChange={handleTriggerChange}
          />
        ) : (
          ""
        )}
      </tr>
      {payment.payable_ac_number !== "Direct Payment" ? (
        <tr className={`pay-details-hide-${payCount}`}>
          <td>
            Mode <span className="col-red">*</span>
          </td>
          <td>
            <SingleSelectDropDown
              dataArr={paymentMode}
              handleChange={(e) => handleInputChange(e, idx, "payment_mode")}
              name={`payment_mode_${payCount}`}
              disabled={
                OfflinePaymentModes.includes(payment.payment_mode) &&
                disableValues
                  ? true
                  : payment.disabledPaymentMode
              }
              required={true}
              value={payment.payment_mode ? payment.payment_mode : ""}
              className={payment.paymentModeClass}
              divClassName="form-group payment-dropdown-tranche-form"
            />
          </td>
          {stepDetails.checklist && showTrancheChecklist ? (
            <FormTriggers
              triggerName={`payment_mode_${payCount}`}
              disabled={disable}
              showYesButton={
                verifyCheckBoxes(payment, user.dts_user) || checkPaymentMode
              }
              showNoButton={
                verifyCheckBoxes(payment, user.dts_user) || uncheckPaymentMode
              }
              errorClass={
                payment.showPaymentModeTriggerError ? "has-error" : ""
              }
              triggerValues={checkpoints}
              caseDetails={caseDetails}
              handleTriggerChange={handleTriggerChange}
            />
          ) : (
            ""
          )}
        </tr>
      ) : (
        ""
      )}

      <tr>
        <td width="30%">
          Payer A/C
          <span className="col-red">*</span>
        </td>
        <td width="45%">
          <SingleSelectDropDown
            dataArr={
              payment.payeeAccNoList
                ? payment.payeeAccNoList
                : state.payerAccount
            }
            handleChange={(e) => handleInputChange(e, idx, "payable_ac_number")}
            name={payable_ac_number}
            disabled={
              payment.payable_ac_number === "Direct Payment"
                ? true
                : payment?.payableDis
                  ? payment?.payableDis
                  : payment.disabledPayableAcNumber
            }
            required={true}
            value={payment.payable_ac_number ? payment.payable_ac_number : ""}
            className={payment.payableAcNumberClass}
            divClassName="form-group payment-dropdown-tranche-form"
          />
          {payment.showResubmitSpan ? (
            <span className="label red-status">
              Resubmitted from :{" "}
              {payment.resubmittedAccount ? payment.resubmittedAccount : ""}
            </span>
          ) : (
            ""
          )}
          <div className="errorTxt" id={`error_payable_ac_number_${payCount}`}>
            {payment.errorpayableAcNumberMsg
              ? payment.errorpayableAcNumberMsg
              : ""}
          </div>
        </td>
        {stepDetails.checklist && showTrancheChecklist ? (
          <FormTriggers
            triggerName={`payable_ac_number_${payCount}`}
            disabled={disable}
            showYesButton={
              verifyCheckBoxes(payment, user.dts_user) || checkPayableAcNumber
            }
            showNoButton={
              verifyCheckBoxes(payment, user.dts_user) || uncheckPayableAcNumber
            }
            width="25%"
            errorClass={
              payment.showPayableAcNumberTriggerError ? "has-error" : ""
            }
            triggerValues={checkpoints}
            caseDetails={caseDetails}
            handleTriggerChange={handleTriggerChange}
          />
        ) : (
          ""
        )}
      </tr>
      {isCancellation ? (
        <tr>
          <td width="20%">
            Tranche Name
            <button
              type="cancellation-tooltip"
              title="More Details"
              onClick={(e) => {
                e.preventDefault();
                toggleCancellationTooltip(idx);
              }}
              className="ic_info"
            >
              <img
                src={`${process.env.REACT_APP_STYLES_PATH}info-icon.png`}
                alt=""
              />
            </button>
            {payment.showCancellationTooltip ? (
              <div className="trache_tooltip_wrapper cancellation-tooltip">
                <div className="x_panel">
                  <div className="x_title">
                    <h2>Cancellation Detail from LoanBox</h2>
                    <div className="clearfix"></div>
                  </div>
                  <div
                    className="x_content"
                    style={{
                      padding: "0px",
                    }}
                  >
                    <div className="table-responsive">
                      <table className="table table-bordered">
                        <tbody>
                          <tr className="headings">
                            <td width="70%" className="column-title">
                              Recovered Loan Amount
                            </td>
                            <td width="30%">
                              <span className="fa fa-inr"></span>
                              {formatAmount(
                                parseInt(
                                  trancheCancellationData.recovered_amount,
                                ),
                              )}
                            </td>
                          </tr>
                          <tr className="headings">
                            <td width="70%" className="column-title">
                              Cancellation Charge Recieved
                            </td>
                            <td width="30%">
                              <span className="fa fa-inr"></span>
                              {formatAmount(
                                parseInt(
                                  trancheCancellationData.cancellation_charges,
                                ),
                              )}
                            </td>
                          </tr>
                          {+trancheCancellationData.is_approval_required ===
                          1 ? (
                            <>
                              <tr className="headings">
                                <td width="70%" className="column-title">
                                  Total Cancellation Charge
                                </td>
                                <td width="30%">
                                  <span className="fa fa-inr"></span>
                                  {formatAmount(
                                    parseInt(
                                      trancheCancellationData.approved_cancellation_charges,
                                    ),
                                  )}
                                </td>
                              </tr>
                              <tr className="headings">
                                <td width="70%" className="column-title">
                                  Money to be returned to Bank
                                </td>
                                <td width="30%">
                                  <span className="fa fa-inr"></span>
                                  {formatAmount(
                                    parseInt(
                                      trancheCancellationData.total_return_amount,
                                    ),
                                  )}
                                </td>
                              </tr>
                              <tr className="headings">
                                <td width="70%" className="column-title">
                                  Amount to be paid from Float
                                </td>
                                <td width="30%">
                                  <span className="fa fa-inr"></span>
                                  {formatAmount(
                                    parseInt(
                                      trancheCancellationData.total_float_amount,
                                    ),
                                  )}
                                </td>
                              </tr>
                            </>
                          ) : (
                            <tr className="headings">
                              <td width="70%" className="column-title">
                                Money to be returned to Bank
                              </td>
                              <td width="30%">
                                <span className="fa fa-inr"></span>
                                {formatAmount(
                                  parseInt(
                                    trancheCancellationData.return_to_bank_amount,
                                  ),
                                )}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </td>
          <td width="25%">Payment Cancellation</td>
        </tr>
      ) : idx ? (
        <>
          <tr>
            <td width="30%">Tranche Name</td>

            {!disableMaker ? (
              <td width="45%">
                <div className="ms-drpdwn">
                  <MultiSelectDropDown
                    data={
                      payment.trancheNameListData
                        ? payment.trancheNameListData
                        : []
                    }
                    handleCheckboxChange={handleCheckboxChange}
                    toggleDropDown={toggleDropDown}
                    dropdownContainer={dropdownContainer}
                    title="Tranche Name"
                    filterName="trancheNameListData"
                  />
                </div>
              </td>
            ) : (
              <td width="25%">{payment.tranche_name}</td>
            )}
            {stepDetails.checklist && showTrancheChecklist ? (
              <FormTriggers
                triggerName={trancheName}
                disabled={disable}
                showYesButton={
                  verifyCheckBoxes(payment, user.dts_user) || checkTrancheName
                }
                showNoButton={
                  verifyCheckBoxes(payment, user.dts_user) || uncheckTrancheName
                }
                errorClass={
                  payment.showTrancheNameTriggerError ? "has-error" : ""
                }
                triggerValues={checkpoints}
                caseDetails={caseDetails}
                handleTriggerChange={handleTriggerChange}
              />
            ) : (
              ""
            )}
          </tr>
        </>
      ) : (
        ""
      )}
      <tr
        className={`pType-box-${payCount} payee-box-${payCount}`}
        style={
          payment.payee_type !== 5
            ? {
                display: "none",
                backgroundColor: "#fdfdfd",
              }
            : {}
        }
      >
        <td>Reason for Deviation</td>
        <td>
          <SingleSelectDropDown
            dataArr={ReasonForDeviation}
            handleChange={(e) =>
              handleInputChange(e, idx, "devition_reason_id")
            }
            name={devitionReasonId}
            disabled={false}
            required={true}
            value={payment.devition_reason_id ? payment.devition_reason_id : ""}
          />
        </td>
        <FormTriggers
          triggerName={devitionReasonId}
          disabled={disable}
          showYesButton={checkDevitionReasonId}
          showNoButton={uncheckDevitionReasonId}
          triggerValues={checkpoints}
          caseDetails={caseDetails}
          handleTriggerChange={handleTriggerChange}
        />
      </tr>
      {showPreviousLoanDetails ? (
        <tr>
          <td>
            <div className={tuMatchFinancier.class}>
              Previous Financier Name
            </div>
          </td>
          {!disableMaker ? (
            <td>
              <input
                type="text"
                value={previous_financier ? previous_financier : ""}
                id={previousFinancier}
                name={previousFinancier}
                placeholder="Previous Financier Name"
                title="correct"
                pattern="^[a-zA-Z][a-zA-Z ]{2,}$"
                className="form-control"
                onChange={(e) =>
                  handleInputChange(e, idx, "previous_financier")
                }
              />
              <div
                className="errorTxt"
                id={`error_previous_financier_${payCount}`}
              ></div>
            </td>
          ) : (
            <td className={tuMatchFinancier.class}>
              {previous_financier === "" ? "NA" : previous_financier}
              <input
                type="hidden"
                value={previous_financier ? previous_financier : ""}
                id={previousFinancier}
                name={previousFinancier}
                readOnly
              />
            </td>
          )}
          {stepDetails.checklist && showTrancheChecklist ? (
            <FormTriggers
              triggerName={previousFinancier}
              disabled={disable}
              showYesButton={
                verifyCheckBoxes(payment, user.dts_user) ||
                checkPreviousFinancier
              }
              showNoButton={
                verifyCheckBoxes(payment, user.dts_user) ||
                uncheckPreviousFinancier
              }
              errorClass={
                payment.showPreviousFinancierTriggerError ? "has-error" : ""
              }
              triggerValues={checkpoints}
              caseDetails={caseDetails}
              handleTriggerChange={handleTriggerChange}
            />
          ) : (
            ""
          )}
        </tr>
      ) : (
        ""
      )}
      {showPreviousLoanDetails ? (
        <tr>
          <td>
            <div className={tuMatchLoanAccount.class}>
              Previous Loan A/C No.
            </div>
          </td>
          {!disableMaker ? (
            <td>
              <input
                type="text"
                value={previous_loan_account ? previous_loan_account : ""}
                id={previousLoanAccount}
                name={previousLoanAccount}
                placeholder="Previous Loan A/C No."
                title="correct"
                className="form-control"
                onChange={(e) =>
                  handleInputChange(e, idx, "previous_loan_account")
                }
              />
              <div
                className="errorTxt"
                id={`error_previous_loan_account_${payCount}`}
              ></div>
            </td>
          ) : (
            <td className={tuMatchLoanAccount.class}>
              {previous_loan_account === "" ? "NA" : previous_loan_account}
              <input
                type="hidden"
                value={previous_loan_account ? previous_loan_account : ""}
                id={previousLoanAccount}
                name={previousLoanAccount}
                readOnly
              />
            </td>
          )}
          {stepDetails.checklist && showTrancheChecklist ? (
            <FormTriggers
              triggerName={previousLoanAccount}
              disabled={disable}
              showYesButton={
                verifyCheckBoxes(payment, user.dts_user) ||
                checkPreviousLoanAccount
              }
              showNoButton={
                verifyCheckBoxes(payment, user.dts_user) ||
                uncheckPreviousLoanAccount
              }
              errorClass={
                payment.showPreviousLoanAccountTriggerError ? "has-error" : ""
              }
              triggerValues={checkpoints}
              caseDetails={caseDetails}
              handleTriggerChange={handleTriggerChange}
            />
          ) : (
            ""
          )}
        </tr>
      ) : (
        ""
      )}
      <tr>
        <td>
          <div className={tuMatchPayeeName.class}>
            Payee Name <span className="col-red">*</span>
          </div>
          {(payment.payee_type === 4 || payment.payee_type === 10) && (
            <div>
              <span className={`label control-status-button ${verifiedCls}`}>
                {verifiedTxt}
              </span>
            </div>
          )}
        </td>
        {!disableMaker ? (
          <td>
            <input
              type="text"
              value={
                payee_name
                  ? maskPayeeAccountText(payee_name, disableValues)
                  : ""
              }
              id={payeeName}
              name={payeeName}
              placeholder="Enter Payee Name"
              title={
                payee_name
                  ? maskPayeeAccountText(payee_name, disableValues)
                  : ""
              }
              pattern="^[a-zA-Z][a-zA-Z ]{2,}$"
              className={`form-control ${
                payment.payeeNameClass ? payment.payeeNameClass : ""
              }`}
              onChange={(e) => handleInputChange(e, idx, "payeeNameVal")}
              readOnly={payment.payeeNameReadOnly}
              disabled={
                formFieldState[idx]?.forceEditable ? false : disableValues
              }
            />
            <div className="errorTxt" id={`error_payee_name_${payCount}`}>
              {payment.errorpayeeNameMsg ? payment.errorpayeeNameMsg : ""}
            </div>
          </td>
        ) : (
          <td className={tuMatchPayeeName.class}>
            {(btnDisplayHOD || btnDisplayPaylead) && payCount === dtsPaymentMax
              ? maskPayeeAccountText(payee_name, disableValues)
              : payee_name}
            {/* {payee_name === "" ? "NA" : maskPayeeAccountText(payee_name)} */}
            <input
              type="hidden"
              value={payee_name ? payee_name : ""}
              className={payment.payeeNameClass ? payment.payeeNameClass : ""}
              id={payeeName}
              name={payeeName}
              onChange={(e) => handleInputChange(e, idx, "payeeNameVal")}
              readOnly={payment.payeeNameReadOnly}
            />
          </td>
        )}
        {stepDetails.checklist && showTrancheChecklist ? (
          <FormTriggers
            triggerName={payeeName}
            disabled={disable}
            showYesButton={
              verifyCheckBoxes(payment, user.dts_user) || checkPayeeName
            }
            showNoButton={
              verifyCheckBoxes(payment, user.dts_user) || uncheckPayeeName
            }
            errorClass={payment.showPayeeNameTriggerError ? "has-error" : ""}
            triggerValues={checkpoints}
            caseDetails={caseDetails}
            handleTriggerChange={handleTriggerChange}
          />
        ) : (
          ""
        )}
      </tr>
      {payment.payable_ac_number !== "Direct Payment" &&
      (!OfflinePaymentModes.includes(payment.payment_mode) ||
        !disableValues) ? (
        <tr className={`pay-details-hide-${payCount}`}>
          <td className={`${tuMatchPayeeAcNumber.class}`}>
            Payee A/C
            <span className="col-red">*</span>
            {+payment.payee_type === 1 && (
              <div>
                <span className={`label control-status-button ${verifiedCls}`}>
                  {verifiedTxt}
                </span>
              </div>
            )}
          </td>

          {!disableMaker ? (
            <td>
              <input
                type={disableValues ? "text" : "password"}
                value={
                  payee_ac_number
                    ? disableValues
                      ? maskString(payee_ac_number, "payee_acc_no")
                      : payee_ac_number
                    : ""
                }
                id={payeeAccountNo}
                name={payeeAccountNo}
                placeholder="Enter Account Number"
                className={`form-control ${
                  payment.payeeAccountNoClass ? payment.payeeAccountNoClass : ""
                }`}
                onChange={(e) => handleInputChange(e, idx, "payee_ac_number")}
                onPaste={(e) => e.preventDefault()}
                readOnly={payment.payeeAcNumberReadOnly}
                onBlur={() => validateAccNumberFunc(idx)}
                disabled={disableValues}
              />
              <div
                className="errorTxt"
                id={`error_payee_ac_number_${payCount}`}
              >
                {payment.errorpayeeAccountNoMsg
                  ? payment.errorpayeeAccountNoMsg
                  : ""}
              </div>
            </td>
          ) : (
            <td className={tuMatchPayeeAcNumber.class}>
              {(btnDisplayHOD || btnDisplayPaylead) &&
              payCount === dtsPaymentMax
                ? maskString(payee_ac_number, "payee_acc_no")
                : payee_ac_number}
              <input
                type="hidden"
                value={payee_ac_number ? payee_ac_number : ""}
                id={payeeAccountNo}
                name={payeeAccountNo}
                onChange={(e) => handleInputChange(e, idx, "payee_ac_number")}
                readOnly={payment.payeeAcNumberReadOnly}
                className={
                  payment.payeeAccountNoClass ? payment.payeeAccountNoClass : ""
                }
              />
            </td>
          )}
          {stepDetails.checklist && showTrancheChecklist ? (
            <FormTriggers
              triggerName={payeeAccountNo}
              disabled={disable}
              showYesButton={
                verifyCheckBoxes(payment, user.dts_user) || checkPayeeAcNumber
              }
              showNoButton={
                verifyCheckBoxes(payment, user.dts_user) || uncheckPayeeAcNumber
              }
              errorClass={
                payment.showPayeeAcNumberTriggerError ? "has-error" : ""
              }
              triggerValues={checkpoints}
              caseDetails={caseDetails}
              handleTriggerChange={handleTriggerChange}
            />
          ) : (
            ""
          )}
        </tr>
      ) : (
        ""
      )}
      {!disableMaker &&
      payment.payable_ac_number !== "Direct Payment" &&
      (!OfflinePaymentModes.includes(payment.payment_mode) ||
        checkPayeeNameHavAcc(payee_name) ||
        !disableValues) ? (
        <tr className="pay-details-hide-1">
          <td>
            {OfflinePaymentModes.includes(payment.payment_mode) && disableValues
              ? "Payee/Foreclosure A/C No"
              : "Re-Enter Payee A/C"}
            <span className="col-red">*</span>
          </td>
          <td>
            <input
              type="text"
              id={`confirm_payee_ac_number_${payCount}`}
              name={`confirm_payee_ac_number_${payCount}`}
              value={
                payment.confirmPayeeAcNumber ? payment.confirmPayeeAcNumber : ""
              }
              placeholder="Re-Enter Account Number"
              className={`form-control ${
                payment.confirmPayeeAcNumberClass
                  ? payment.confirmPayeeAcNumberClass
                  : ""
              }`}
              onPaste={(e) => e.preventDefault()}
              onChange={(e) =>
                handleInputChange(e, idx, "confirmPayeeAcNumber")
              }
              onBlur={() => validateAccNumberFunc(idx)}
            />
            <div
              className={
                payment.errorConfirmPayeeAcNumberClass
                  ? payment.errorConfirmPayeeAcNumberClass
                  : "errorTxt"
              }
              id={`error_confirm_payee_ac_number_${payCount}`}
            >
              {payment.errorconfirmPayeeAcNumberMsg
                ? payment.errorconfirmPayeeAcNumberMsg
                : ""}
            </div>
          </td>
          {payment.showValidateAccountBtn && (
            <td>
              <input
                type="hidden"
                id={`existed_payee_account_${payCount}`}
                name={`existed_payee_account_${payCount}`}
                value={existed_payee_account}
                onChange={(e) =>
                  handleInputChange(e, idx, "existed_payee_account")
                }
              />
              <input
                type="hidden"
                id={`existed_payee_name_${payCount}`}
                name={`existed_payee_name_${payCount}`}
                value={existed_payee_name}
                onChange={(e) =>
                  handleInputChange(e, idx, "existed_payee_name")
                }
              />
              <button
                id="validateAccountBtn"
                className="btn btn-edit"
                type="button"
                onClick={(e) => validateOTP(e, idx)}
                disabled={payment.disabled_validateAccountBtn}
              >
                Validate
              </button>
            </td>
          )}
        </tr>
      ) : (
        ""
      )}
    </>
  );
};

export default PayeeAndPayerDetails;
